/*
Holiday destinations by theme
*/

import React from "react";
import { Link } from "gatsby";

import VacationCardCarousel from "./vacationcard-carousel";
import PropertyCardCarousel from "./propertycard-carousel";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons";

const SwiperCards = ({ cards, type, small, title, subtitle, seeAllUrl }) => {
  let cardsCarousel;
  if (type === "vacation-card") {
    cardsCarousel = <VacationCardCarousel cards={cards} />;
  } else if (type === "property-card") {
    cardsCarousel = <PropertyCardCarousel cards={cards} small={small} />;
  }

  let seeAll;
  if (seeAllUrl) {
    seeAll = (
      <div className="col-md-3 d-lg-flex align-items-center justify-content-end">
        <Link to={seeAllUrl} className="text-muted text-sm">
          Katso kaikki
          <FontAwesomeIcon icon={faAngleDoubleRight} fixedWidth size="xs" />
        </Link>
      </div>
    );
  }

  return (
    <>
      <div className="row mb-2">
        <div className="col-md-9">
          <p className="subtitle text-primary">
            {subtitle}
            {/* {"  ·  "}
            {title} */}
          </p>
        </div>
        {seeAll}
      </div>
      <div className="row">
        <div style={{ width: "100%" }}>{cardsCarousel}</div>
      </div>
    </>
  );
};

export default SwiperCards;
